import store from "@/store";

export default function cancelPendingRequests({
  from,
}) {
  const { pendingRequests } = store.state.Loader;

  pendingRequests.forEach((request) => {
    if (from.name === request.initiator && request.cancelWhenLeaveInitiator) {
      request.controller.abort({
        requestId: request.id,
        message: "abort",
        isClientError: true,
      });
    }
  });
}
